
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Plus from "../../../src/assests/images/Plus.svg";
import { getToken } from "../../utils/utils";
import {
  Box,
  Typography,
  Link,
  Button,
  TextField,
  InputAdornment,
  List,
  ListItem,
  Tooltip,
} from "@mui/material";
import DashboardTabPanel from "../../components/Dashboard/DashboardTabPanel";
import PriorityUsers from "../../components/Dashboard/PriorityUsers";
import { dashboarddetails } from "../../components/Dashboard/api";


function Dashboard() {

  const [location, setLocation] = React.useState("All Locations");
  
    const [dropdownValue, setDropdownValue] = React.useState("");
    
    const [useranalysis, setuseranalysis] = React.useState("");
    const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
   
      const [retailersData, setRetailersData] = useState<[]>([]);
      
      
      const [outletlength, setoutletlength] = useState("");
      const [tasksummary, settasksummary] = useState<[]>([]);
      const [outletsdata, setoutlets] = useState<[]>([]);
      
      const [xlabels, setxlabels] = useState<[]>([]);
      
      const [ylabels, setylabels] = useState<[]>([]);
      const [ylabels1, setylabels1] = useState<[]>([]);
      
      const [xlabels1, setxlabels1] = useState<[]>([]);
    const [isLoading, setIsLoading] = useState(true);
const token = getToken();



useEffect(() => {
  setDropdownValue("");
  settasksummary([]);
  setoutletlength("");
  setuseranalysis("");
  setoutlets([]);
}, [value]); 


useEffect(() => {
  const fetchData = async () => {
    setIsLoading(true);

    const reqBody = {
      task_id: dropdownValue || "",
      location: location !== "All Locations" ? location : "",
      day: value === 0 ? "today" : value === 1 ? "yesterday" :  value === 2 ? "last7days":value === 3 ? "last6months":"",
    };
    

    try {
      const response = await dashboarddetails(reqBody, token);

      const mappedData = response.data.data.task_summary.map((item: any) => {
        const colorMap: { [key: string]: string } = {
          Opened: "#B90022",
          Submitted: "#3BA755",
          Reattempted: "#B90022",
          Completed: "green",
          "Not Started": "#3BA755",
        };

        const trendMap: { [key: string]: string } = {
          Opened: "down",
          Submitted: "up",
          Reattempted: "down",
          Completed: "up",
          "Not Started": "up",
        };

        return {
          value: item.value,
          percentage: item.percentage,
          label: item.label,
          color: colorMap[item.label] || "gray",
          trend: trendMap[item.label] || "neutral",
        };
      });

      settasksummary(mappedData);

      const outletsData1 = response.data.data.totaloutlets.map((item: any) => ({
        city: `${item.billing_city}, ${item.billing_country}`,
        contact_count: item.contact_count,
      }));

      setoutletlength(response.data.data.totalOutletslength);
      setuseranalysis(response.data.data.user_analysis);
      setoutlets(outletsData1);
      setxlabels(response.data.data.user_x_labels)
      setylabels(response.data.data.user_y_labels)
      setxlabels1(response.data.data.task_x_labels)
      setylabels1(response.data.data.task_y_labels)
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchData();
}, [token, location, dropdownValue, value]);
      console.log(tasksummary, "tasksummarytasksummary")
      console.log(location, "locationlocationlocationssss" )
      console.log(value, "nnnnnnnnnnnnnnnn")
   



   
      console.log(value, "useranalysisuseranalysis")
  return (
    <div>
      <Box
        sx={{
          padding: "24px 32px 50px",
          background: "#fff ",
          borderBottom: "1px solid #E7E8E9",
        }}
      >
        <Link
          href="#"
          sx={{
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: "600",
            color: "rgba(142, 2, 15, 1)",
          }}
        >
          Dashboard
        </Link>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: "24px",
                fontWeight: "600",
                color: "#000",
                marginTop: "16px",
              }}
            >
              Welcome to Dashboard Aman !!
            </Typography>
          </Box>
          <Box sx={{ display: "flex", marginRight: "20px" }}>
            <Button
              sx={{
                borderRadius: "8px",
                padding: "14px 16px",
                color: "#c8172f",
                textDecoration: "none",
                border: "1px solid #c8172f",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "500",
                textTransform: "none",
                marginRight: "20px",
              }}
            >
              View Task Report
            </Button>
            <Button
              onClick={() => navigate("/manage-task/create-task")}
              sx={{
                borderRadius: "8px",
                padding: "14px 16px",
                color: "#FFF",
                textDecoration: "none",
                background: "rgba(200, 23, 47, 1)",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "500",
                textTransform: "none",
              }}
            >
              <img style={{ marginRight: "8px" }} src={Plus} alt="Plus" />{" "}
              Create Task
            </Button>
          </Box>
        </Box>
      </Box>
      {/* <!--Dashboard Tabs--> */}
      <Box
        sx={{
          display: "flex",
          background: "#F9FBFC",
          padding: "20px 32px",
        }}
      >
        <Box sx={{ width: "60%" }}>
          <DashboardTabPanel   location={location} 
        setLocation={setLocation} setValue={setValue} value={value} setDropdownValue={setDropdownValue} dropdownValue={dropdownValue} tasksummary={tasksummary}outletsdata={outletsdata} outletlength={outletlength} useranalysis={useranalysis} xlabels={xlabels} ylabels={ylabels} ylabels1={ylabels1} xlabels1={xlabels1}/>
        </Box>
        <Box>
          <PriorityUsers />
        </Box>
      </Box>
    </div>
  );
}

export default Dashboard;